var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-container"},[_c('div',{staticClass:"router-container"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{key:_vm.$route.params.company_id,staticClass:"router-view"})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }